"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeCode = exports.isCardDetails = exports.isCardDetailsBase = void 0;
const isCardDetailsBase = (val) => val != null &&
    typeof (val) === 'object' &&
    (typeof val.suffix === 'string' || typeof val.suffix === 'undefined') &&
    typeof val.expirationMonth === 'string' &&
    typeof val.expirationYear === 'string' &&
    typeof val.type === 'string';
exports.isCardDetailsBase = isCardDetailsBase;
const isCardDetails = (val) => (0, exports.isCardDetailsBase)(val) &&
    typeof val.suffix === 'string';
exports.isCardDetails = isCardDetails;
// Reference: https://developer.cybersource.com/docs/cybs/en-us/apifields/reference/all/rest/api-fields/cons-auth-info/cons-auth-info-challenge-code.html
var ChallengeCode;
(function (ChallengeCode) {
    ChallengeCode["NO_PREFERENCE"] = "01";
    ChallengeCode["NO_CHALLENGE_REQUEST"] = "02";
    ChallengeCode["CHALLENGE_REQUESTED"] = "03";
    ChallengeCode["CHALLENGE_REQUESTED_MANDATE"] = "04";
    ChallengeCode["NO_CHALLENGE_RISK_ANALYSIS_ALREADY_PERFORMED"] = "05";
    ChallengeCode["NO_CHALLENGE_NO_MONEY_TRANSFERRED"] = "06";
    ChallengeCode["NO_CHALLENGE_SCA_ALREADY_PERFORMED"] = "07";
    ChallengeCode["NO_CHALLENGE_CARDHOLDER_ON_ALLOW_LIST"] = "08";
    ChallengeCode["CHALLENGE_REQUESTED_BY_ISSUER"] = "09";
})(ChallengeCode = exports.ChallengeCode || (exports.ChallengeCode = {}));
